// src/config/apiRoutes.js

const BASE_URL = process.env.REACT_APP_BASE_URL // Base API URL

const API_ROUTES = {
  AUTH: {
    LOGIN: `${BASE_URL}/api/v2/admins/login`,
    // LOGOUT: `${BASE_URL}/auth/logout`,
    CREATE: `${BASE_URL}/api/v2/admins/create-admin`,
    GET_ALL: `${BASE_URL}/api/v2/admins/filter`,
    UPDATE: (id) => `${BASE_URL}/api/v2/admins/${id}`,
    DELETE: (id) => `${BASE_URL}/api/v2/admins/${id}`,
  },
  CATEGORIES: {
    GET_ALL: `${BASE_URL}/api/v2/categories/filter`,
    CREATE: `${BASE_URL}/api/v2/categories/admins/create-category`,
    UPDATE: (id) => `${BASE_URL}/api/v2/categories/admins/update-category/${id}`,
    DELETE: (id) => `${BASE_URL}/api/v2/categories/admins/delete-category/${id}`,
  },
  BANNERS: {
    GET_ALL: `${BASE_URL}/api/v2/banners/filter`,
    CREATE: `${BASE_URL}/api/v2/banners/admins`,
    UPDATE: (id) => `${BASE_URL}/api/v2/banners/admins/${id}`,
    DELETE: (id) => `${BASE_URL}/api/v2/banners/admins/${id}/delete`,
  },
  COUNTRIES: {
    GET_ALL: `${BASE_URL}/api/v2/countries/filter`,
    CREATE: `${BASE_URL}/api/v2/countries/admins/create-country`,
    UPDATE: (id) => `${BASE_URL}/api/v2/countries/admins/update-country/${id}`,
    DELETE: (id) => `${BASE_URL}/api/v2/countries/admins/delete-country/${id}`,
  },
  SUBSCRIPTIONS: {
    GET_ALL: `${BASE_URL}/api/v2/subscription-packages/filter`,
    CREATE: `${BASE_URL}/api/v2/subscription-packages/admins/create-subscription-package`,
    UPDATE: (id) => `${BASE_URL}/api/v2/subscription-packages/admins/update-subscription-package/${id}`,
    DELETE: (id) => `${BASE_URL}/api/v2/subscription-packages/admins/delete-subscription-package/${id}`,
  },
  Orders : {
    GET_ALL: `${BASE_URL}/api/v2/orders/filter`,
    CREATE: `${BASE_URL}/api/v2/orders/admins/create-order`,
    UPDATE: (id) => `${BASE_URL}/api/v2/orders/${id}`,
    DELETE: (id) => `${BASE_URL}/api/v2/orders/admins/delete-order/${id}`,
  },
  Users: {
    GET_ALL: `${BASE_URL}/api/v2/users/filter`,
    GET_USER_DETAIL: (id) => `${BASE_URL}/api/v2/users/admin/user-details/${id}`,
    GET_AUCTIONS: `${BASE_URL}/api/v2/auctions/filter`,
    UPDATE_AUCTION_STATUS: (id) => `${BASE_URL}/api/v2/auctions/admin/update-status/${id}`,
    IDENTITY_VERIFICATION_FILTER:`${BASE_URL}/api/v2/admins/users/identity-verification/filter`,
    IDENTITY_VERIFICATION:`${BASE_URL}/api/v2/admins/users/identity-verification`,
    UPDATE_VERIFICATION_STATUS:`${BASE_URL}/api/v2/admins/users/identity-verification`,
    SYNC_WITH_MYFATORAH: (id) => `${BASE_URL}/api/v2/admins/identity-verification/upload-supplier-documents-to-myfatoorah/${id}`,
    CHECK_MYFATORAH_STATUS: (id) => `${BASE_URL}/api/v2/admins/identity-verification/supplier-status/${id}`,
  },
  CLIPS: {
    GET_ALL: `${BASE_URL}/api/v2/clips/users/filter`,
    UPDATE_STATUS: (id) => `${BASE_URL}/api/v2/clips/admin/update-status/${id}`,
  },
  Withdrawals: {
    GET_ALL: `${BASE_URL}/api/v2/withdrawls/filter`,
    UPDATE: (id) => `${BASE_URL}/api/v2/withdrawls/admins/${id}`,
    DELETE: (id) => `${BASE_URL}/api/v2/withdrawls/admins/${id}`
  },
  TICKETS: {
    GET_ALL: `${BASE_URL}/api/v2/tickets/admins/filter`,
    GET_DETAIL: (id) => `${BASE_URL}/api/v2/tickets/${id}`,
    REPLY: (id) => `${BASE_URL}/api/v2/tickets/${id}`,
    UPDATE_STATUS: (id) => `${BASE_URL}/api/v2/tickets/admins/${id}/status`,
  },
  DASHBOARD: {
    GET_STATISTICS: (from, to) => `${BASE_URL}/api/v2/dashboard/statistics?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`,
  },
  LANGUAGES: {
    GET_ALL: `${BASE_URL}/api/v2/languages/filter`,
    CREATE: `${BASE_URL}/api/v2/languages/admins`,
    UPDATE: (key) => `${BASE_URL}/api/v2/languages/admins/${key}`,
    DELETE: (key) => `${BASE_URL}/api/v2/languages/admins/${key}`,
  },
  CHANNELS: {
    GET_ALL: `${BASE_URL}/api/v2/channels/filter`,
    CREATE: `${BASE_URL}/api/v2/channels/create`,
    UPDATE: (id) => `${BASE_URL}/api/v2/channels/update/${id}`,
    UPDATE_STATUS: (channelId) => `${BASE_URL}/api/v2/channels/admin/update-status/${channelId}`,
  },
};

export default API_ROUTES;